var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "header__cart cart-icon",
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.onCartOpen.apply(null, arguments)
        },
      },
    },
    [
      _c("SVGCart", { staticClass: "header__cart-icon" }),
      _vm._v(" "),
      _vm.totalItemsWithoutAdditional
        ? _c("span", {
            staticClass: "header__cart-count",
            domProps: { innerHTML: _vm._s(_vm.totalItemsWithoutAdditional) },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }